// Contact.js
export default function Contact() {
    return (
        <section id="contact"
                 className="my-40 align-center max-w-5xl mx-auto p-3">
            <h2 className="text-5xl font-bold text-emerald-500 text-center">
                Contact
            </h2>
            <div className="flex gap-5 justify-center 
                        my-10">
                              <a rel="noreferrer"
                   target="_blank"
                   className="text-center hover:underline"
                   href=
"https://www.linkedin.com/in/shivam0yadav001/">
                    LinkedIn:
                    <span className="font-bold">
                        @Shivam Yadav
                    </span>
                </a>
           
                <a rel="noreferrer"
                   target="_blank"
                   className="text-center hover:underline"
                   href=
"https://www.instagram.com/its_shivss_?igsh=ZWQ1bGE2bXJpa21t">
                    Instagram:
                    <span className="font-bold">
                      @its_shivss_
                    </span>
                </a>


                <a rel="noreferrer"
                   target="_blank"
                   className="text-center hover:underline"
                   href=
                    "Ssy02092004@gmail.com">
                   E-mail:
                    <span className="font-bold">
                     @ Ssy02092004@gmail.com
                    </span>
                </a>
                </div>
              
        </section>
    );
}
